
import { mapGetters } from 'vuex';
import eventTrackingMixins from '~/mixins/eventTrackingMixins.js';
import blogRelatedProductMixin from '~/mixins/eventTrackingBlogRelatedProductMixins.js';
import processImageLink from '~/mixins/processImageLink.js';
import lgmMixin from '~/mixins/lgmMixin';

export default {
  name: "BlogSingle",
  mixins: [eventTrackingMixins, processImageLink, lgmMixin, blogRelatedProductMixin],
  props: {
    data: {
      type: Object,
      default: () => { },
    },
  },
  data() {
      return {
        strapiData: [],
        componentRendered: false,
      };
  },
  computed: {
    blogCategoryTags() {
      const tags = this.data?.blog_categories
      const uniqueTags = tags.filter((obj, index) => {
        return index === tags.findIndex(o => obj.DisplayName === o.DisplayName) && !this.isFunctionalBlogTag(obj.TagCode);
      });
      this.$store.commit('blog/setCurrentBlogSingleTags', uniqueTags)
      return uniqueTags
    },

    ...mapGetters({
        showBlogDisclaimerModal: 'modal/showBlogDisclaimerModal',
        disclaimerConfirmedBlogs: 'disclaimerPopup/disclaimerConfirmedBlogs'
      }),

    showAdsense() {
      return this.data?.blog_objectives.filter((item) => item?.code === 'adsense').length > 0;
    },
    blogContentList() {
      if (!this.data?.BlogContent) return [];
        const result = [];
        const groupCount = {};
        this.data.BlogContent.forEach(item => {
        const key = item.__typename;
        groupCount[key] = (groupCount[key] || 0) + 1;
        result.push({
          ...item,
          componentIndex: groupCount[key]
        });
      });
      return result;
    },
  },

  watch: {
    componentRendered(newVal, oldVal) {
      if(newVal !== oldVal) {
        setTimeout(() => {
          this.handleEventTracking_promotionBannerLoaded()
        }, 2000)
      }
    },
  },

  mounted() {

    if (this.$route.hash) {

      this.$nextTick(() => {
        const el = document.querySelector(this.$route.hash)
        const targetElement = el
        if(!targetElement) return

        const navbar = document.querySelector('.nav-bar');
        const height = navbar.offsetHeight;
        let mobileExtra = 0
        if (navigator.userAgent.toLowerCase().match(/mobile/i)) { mobileExtra = 80}
        const scrollTopHeight = (targetElement.offsetTop) - (height + 20 + mobileExtra)

        window.scrollTo({
          top: scrollTopHeight ,
          behavior: "smooth"
        });

        const codeBlocks = document.getElementsByTagName('code');
        const codeBlocksTargetIds = []
        for (const block of codeBlocks) {
          if (block?.innerHTML) {
            codeBlocksTargetIds.push(block.innerHTML)
          }
        }
        if (codeBlocks && codeBlocks.length > 0) {
          for (const block of codeBlocks) {
            const tableBlock = document.getElementsByClassName('table-' + block.innerHTML);
            if (tableBlock && tableBlock[0]) {
              block.innerHTML = tableBlock[0].outerHTML

              const toHideElement = document.querySelectorAll(":not(code)>." + block.firstChild.id);
              toHideElement[0].innerHTML = ''
            }
          };
        }

        this.$store.commit('blog/clearTagCodes')
        this.$store.commit('blog/clearAuthorCodes')
      })

    }

    const disclaimerType = document.querySelectorAll('[data-disclaimer-type]');
    if(disclaimerType && disclaimerType.length > 0) {
      disclaimerType.forEach(
        item => {
          item.addEventListener('click', event => {
            const dataObj = {
              modalType: 'blogDisclaimerModalInfo',
              disclaimerType: `${event.target.dataset.disclaimerType}`
            }
            this.setBlogDisclaimerModalData(dataObj)
            this.openBlogDisclaimerModal()
          })
        }
      )
    }

  },

  updated() {
    this.componentRendered = true
    // this.handleEventTracking_promotionBannerLoaded()
  },


  methods: {
    isSCFont() {
      return this.getFunctionalTag().find((item) => {
        return item?.TagCode === 'fn-font-sc'
      })
    },
    isFunctionalBlogTag(tagCode) {
      return tagCode?.includes("fn-")
    },
    getFunctionalTag() {
      const tags = this.data?.blog_categories
      return tags.filter((obj, index) => {
        return this.isFunctionalBlogTag(obj?.TagCode)
      })
    },

    handleEventTracking_promotionBannerLoaded() {
      const sponsoredPromotionItems = document.querySelectorAll(".sponsored-promotion")

      if (sponsoredPromotionItems?.length > 0) {
        sponsoredPromotionItems.forEach(element => {
          const cardData = this.extractDataFromProductCardNode(element)

          // #1 count sponsoredPromotionItems
          const eventTrackingParams = this.initEventTrackingParams()

          eventTrackingParams.a = 'promo_banner_impression'
          eventTrackingParams.l =  cardData.product.scenario_code
          eventTrackingParams.c = `blog_related_products_promo_banner`
          eventTrackingParams.cd.insurer_name = cardData.product.insurer_name
          eventTrackingParams.cd.product_name = cardData.product.product_name
          eventTrackingParams.cd.product_category = cardData.product.product_category

          this.sendEventTracking(eventTrackingParams)

        });

      }

    },

    openBlogDisclaimerModal() {
      this.$store.commit('modal/setShowBlogDisclaimerModal', true);
    },
    setBlogDisclaimerModalData(dataObj) {
      const obj = {
        modalType: dataObj.modalType,
        disclaimerType: dataObj.disclaimerType,
      }
      this.$store.commit(`modal/setBlogDisclaimerModalData`, obj);
    },

  },

}
